import clsx from "clsx";
import { useRef, useState, useEffect } from "react";
import * as styles from "./styles";
import Gradient from "../Gradient";

export default function ImgComparisonSlider({
    imgBefore,
    imgAfter,
    imgBeforeAlt,
    imgAfterAlt,
    gradient,
    caption,
}) {
    const containerRef = useRef(null);
    const [sliderPosition, setSliderPosition] = useState(50);
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        const handleMove = (e) => {
            if (!isDragging || !containerRef.current) return;

            const containerRect = containerRef.current.getBoundingClientRect();
            const newX =
                e.touches?.[0]?.clientX - containerRect.left ||
                e.clientX - containerRect.left;

            const newPercentage = (newX / containerRect.width) * 100;
            setSliderPosition(Math.max(0, Math.min(100, newPercentage)));
        };

        const stopDrag = () => setIsDragging(false);

        const sliderActions = [
            { action: "mousemove", fn: handleMove },
            { action: "mouseup", fn: stopDrag },
            { action: "touchmove", fn: handleMove },
            { action: "touchend", fn: stopDrag },
        ];

        if (isDragging) {
            sliderActions.map((item) => addEvent(item.action, item.fn));
        }

        return () => {
            sliderActions.map((item) => removeEvent(item.action, item.fn));
        };
    }, [isDragging]);

    return (
        <div className={styles.parentContainer}>
            <div className={clsx(gradient ? "-mt-2 mb-2" : "mb-10")}>
                {gradient && <Gradient {...gradient} />}
            </div>
            <div ref={containerRef} className={styles.container}>
                {/* Before Image (Fixed) */}
                <img
                    src={imgBefore}
                    alt={imgBeforeAlt}
                    className={styles.img}
                />

                {/* After Image (Slides in) */}
                <img
                    src={imgAfter}
                    alt={imgAfterAlt}
                    className={styles.img}
                    style={{
                        clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`,
                    }}
                />

                {/* Slider Handle */}
                <div
                    className={styles.sliderHandle}
                    style={{ left: `${sliderPosition}%` }}
                    onMouseDown={() => setIsDragging(true)}
                    onTouchStart={() => setIsDragging(true)}
                >
                    <div className={styles.handleOnSlider}>
                        {handleOnSlider()}
                    </div>
                </div>
            </div>
            <div className={styles.caption}>{caption}</div>
        </div>
    );
}

const handleOnSlider = () => {
    return (
        <div className="rounded-full bg-offWhite p-0.5 shadow-inner-lg">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="14px"
                width="14px"
                viewBox="0 -960 960 960"
                fill="black"
            >
                <path d="M480-120 300-300l58-58 122 122 122-122 58 58-180 180ZM358-598l-58-58 180-180 180 180-58 58-122-122-122 122Z" />
            </svg>
        </div>
    );
};

// vanilla javascript works smoother for click and drag events
const addEvent = (action, fn) => window.addEventListener(action, fn);
const removeEvent = (action, fn) => window.removeEventListener(action, fn);
